import React from "react";

const NotifyUsersModal = ({
                              isOpen,
                              onClose,
                              onSearchSubmit,
                              filteredUsers = [],
                              selectedUsers = [],
                              setSelectedUsers,
                              onNotifySelected,
                              onNotifyAll,
                              searchQuery,
                              setSearchQuery,
                              modalTitle = "Notify Users",
                              showVersionField = false,
                              selectedVersion = "",
                              setSelectedVersion = () => {},
                          }) => {
    const handleUserSelection = (user) => {
        setSelectedUsers((prev) => {
            const alreadySelected = prev.some((u) => u.id === user.id);
            if (alreadySelected) {
                return prev.filter((u) => u.id !== user.id);
            } else {
                return [...prev, user];
            }
        });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center backdrop-blur-sm">
            <div className="bg-white dark:bg-gray-800 w-full max-w-lg rounded-lg p-6">
                <h2 className="text-lg font-semibold mb-4 dark:text-white text-[#004c86]">
                    {modalTitle}
                </h2>

                {showVersionField && (
                    <div className="mb-4">
                        <label className="block text-sm font-semibold text-[#004c86] dark:text-white mb-2">
                            Firmware Version to Notify
                        </label>
                        <input
                            type="text"
                            value={selectedVersion}
                            onChange={(e) => setSelectedVersion(e.target.value)}
                            placeholder="Enter firmware version"
                            className="w-full border px-3 py-2 rounded dark:bg-gray-700 dark:text-white"
                        />
                    </div>
                )}

                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && onSearchSubmit()}
                    placeholder="Search by mobile number or email address"
                    className="w-full border px-3 py-2 mb-4 rounded dark:bg-gray-700 dark:text-white"
                />

                <div className="max-h-60 overflow-y-auto border rounded-md mb-4">
                    {filteredUsers.length > 0 ? (
                        filteredUsers.map((user) => (
                            <div
                                key={user.id}
                                className="flex justify-between items-center py-2 px-3 border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
                            >
                                <div className="flex items-center space-x-3">
                                    <input
                                        type="checkbox"
                                        checked={selectedUsers.some((u) => u.id === user.id)}
                                        onChange={() => handleUserSelection(user)}
                                        className="cursor-pointer w-4 h-4 accent-[#004c86]"
                                    />
                                    <div className="text-sm dark:text-white">
                                        <p className="font-medium">
                                            {user.name && user.name.trim() !== ""
                                                ? user.name
                                                : user.mobileNumber
                                                    ? user.mobileNumber
                                                    : user.email}
                                        </p>
                                        <p className="text-gray-500 text-xs">
                                            {user.mobileNumber || user.email || ""}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-500 dark:text-gray-300 text-center py-3">
                            No users found.
                        </p>
                    )}
                </div>

                {selectedUsers.length > 0 && (
                    <div className="mb-4 bg-gray-50 dark:bg-gray-700 p-3 rounded-md">
                        <h3 className="text-sm font-semibold text-[#004c86] dark:text-white mb-2">
                            Selected Users ({selectedUsers.length})
                        </h3>
                        <div className="flex flex-wrap gap-2">
                            {selectedUsers.map((user) => (
                                <span
                                    key={user.id}
                                    className="bg-[#004c86] text-white text-xs px-2 py-1 rounded-full flex items-center space-x-1"
                                >
                  <span>
                    {user.name && user.name.trim() !== ""
                        ? user.name
                        : user.mobileNumber
                            ? user.mobileNumber
                            : user.email}
                  </span>
                  <button
                      onClick={() => handleUserSelection(user)}
                      className="ml-1 text-xs font-bold hover:text-gray-200"
                  >
                    ×
                  </button>
                </span>
                            ))}
                        </div>
                    </div>
                )}

                <div className="mt-6 flex justify-between">
                    <button
                        onClick={onNotifySelected}
                        disabled={selectedUsers.length === 0}
                        className={`px-4 py-2 rounded text-white ${
                            selectedUsers.length === 0
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-[#004c86] hover:bg-[#0b83b5]"
                        }`}
                    >
                        Notify Selected
                    </button>

                    <button
                        onClick={onNotifyAll}
                        className="bg-[#0b83b5] hover:bg-green-700 text-white px-4 py-2 rounded"
                    >
                        Notify All
                    </button>

                    <button
                        onClick={onClose}
                        className="bg-gray-300 dark:bg-gray-600 text-black dark:text-white px-4 py-2 rounded hover:bg-gray-400"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotifyUsersModal;